export const getColumns = (intl) => {
  const alert_prior = [
    intl.formatMessage({ id: 'app.alerts.priority.low' }),
    intl.formatMessage({ id: 'app.alerts.priority.medium' }),
    intl.formatMessage({ id: 'app.alerts.priority.high' }),
  ];

  const columns = [
    {
      headerName: intl.formatMessage({ id: 'app.alerts.grid.dateCol' }),
      field: 'created_at',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        fontWeight: '900',
        fontSize: '1em',
        textAlign: 'left',
        width: '15%',
      },
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
    {
      headerName: intl.formatMessage({ id: 'app.alerts.grid.descCol' }),
      field: 'description',
      cellStyle: {
        textAlign: 'left',
        fontWeight: '500',
        width: '30%',
        fontSize: '.95em',
      },
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
    {
      headerName: intl.formatMessage({ id: 'app.alerts.grid.levelCol' }),
      field: 'lvl',
      cellStyle: {
        textAlign: 'left',
        fontWeight: '500',
        width: '15%',
        fontSize: '.95em',
      },
      render: (rowData) => {
        return alert_prior[rowData.lvl - 1] + ' ';
      },
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
    {
      headerName: intl.formatMessage({ id: 'app.alerts.grid.locCol' }),
      field: 'ubication',
      cellStyle: {
        textAlign: 'left',
        fontWeight: '500',
        width: '40%',
        fontSize: '.95em',
      },
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
  ];

  return columns;
};
